import { ActionTree, Commit } from 'vuex';
import { IState } from './state';
import config from '@/params/config';
import * as TYPES from './types';
import { apiFetchAction } from '../apiUtil';

// const apiRoot: string = `${config.neo}/${config.apiVersion}`;
const apiRoot: string = config.neo;

interface IActionContent {
  state: IState;
  commit: Commit;
}

// 查询课程类型
const getContactList = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'ProductSupport/GetProductSupportTree',
    'GET',
    TYPES.CONTACT_LIST,
    payload,
    false,
    apiRoot
  );
};

// 查询课程
const setContactUpdate = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'ProductSupport/SaveProductSupportTree',
    'POST',
    TYPES.CONTACT_UPDATE,
    payload,
    false,
    apiRoot
  );
};

export const actions = {
  getContactList,
  setContactUpdate
};
